import dayjs from 'dayjs';
import { AgxDatePicker, AgxSpacer } from '@urbanx/agx.ui-components2';
import { SubPagePanel } from 'components/panel/SubPagePanel';
import './ConditionDatePicker.scss';

interface ConditionPanelProps {
  id: string;
  panelTitle: string;
  contractDate?: Date;
  onChange: (contractDate: Date | undefined) => void;
  isDocuSigned?: boolean;
}

export function ContractDatePanel({
  id,
  panelTitle,
  contractDate,
  onChange,
  isDocuSigned = false,
}: ConditionPanelProps) {
  return (
    <SubPagePanel key={`deposit-panel-${id}`} expandable panelTitle={panelTitle} defaultExpanded>
      <AgxSpacer
        direction="vertical"
        gap="spacing-xl"
        fill
        padding={{ top: 'spacing-3xl', bottom: 'spacing-3xl' }}
        contentAlignment="start"
      >
        <AgxDatePicker
          id={`${id}-due-date`}
          className="contract-information-date-picker"
          disabled={isDocuSigned}
          label="Date"
          value={contractDate ? dayjs(contractDate).format('YYYY-MM-DD') : ''}
          optionalText=""
          onChange={(value) => onChange(value ?? undefined)}
        />
      </AgxSpacer>
    </SubPagePanel>
  );
}
